import { render } from "./App.vue?vue&type=template&id=3323c4c2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3323c4c2&lang=css"

import exportComponent from "D:\\trax\\my_blog\\my_blog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__